import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Chip, FormControl, InputLabel, Select, MenuItem, Pagination,
} from '@mui/material';
import { offerwallAdminAPI } from '../services/api';
import { formatKstDateTime } from '../utils/datetime';

const fmt = (n: number) => new Intl.NumberFormat('ko-KR').format(n);

const PROVIDER_LABEL: Record<string, string> = { tnk: 'TNK Factory', adpopcorn: 'AdPopcorn' };
const PROVIDER_COLOR: Record<string, any> = { tnk: 'primary', adpopcorn: 'secondary' };

const OfferwallTransactions: React.FC = () => {
  const [provider, setProvider] = useState('');
  const [page, setPage] = useState(1);
  const limit = 20;

  const { data } = useQuery({
    queryKey: ['offerwall-transactions', provider, page],
    queryFn: async () => (await offerwallAdminAPI.getAll({ provider: provider || undefined, page, limit })).data,
  });

  const totalPages = data ? Math.ceil(data.total / limit) : 1;

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>오퍼월 적립 내역</Typography>

      <Box sx={{ mb: 2 }}>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel>오퍼월</InputLabel>
          <Select value={provider} label="오퍼월" onChange={(e) => { setProvider(e.target.value); setPage(1); }}>
            <MenuItem value="">전체</MenuItem>
            <MenuItem value="tnk">TNK Factory</MenuItem>
            <MenuItem value="adpopcorn">AdPopcorn</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell><TableCell>오퍼월</TableCell><TableCell>유저</TableCell>
              <TableCell align="right">적립 포인트</TableCell><TableCell>캠페인</TableCell>
              <TableCell>거래ID</TableCell><TableCell>일시</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.items?.map((o) => (
              <TableRow key={o.id}>
                <TableCell>{o.id}</TableCell>
                <TableCell><Chip label={PROVIDER_LABEL[o.provider] || o.provider} color={PROVIDER_COLOR[o.provider] || 'default'} size="small" /></TableCell>
                <TableCell>#{o.userId}</TableCell>
                <TableCell align="right" style={{ color: '#2e7d32', fontWeight: 700 }}>+{fmt(o.amount)}</TableCell>
                <TableCell>{o.campaign || '-'}</TableCell>
                <TableCell><Typography variant="caption" color="text.secondary">{o.transId}</Typography></TableCell>
                <TableCell>{formatKstDateTime(o.createdAt)}</TableCell>
              </TableRow>
            ))}
            {!data?.items?.length && <TableRow><TableCell colSpan={7} align="center">적립 내역이 없습니다.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>

      {totalPages > 1 && (
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
          <Pagination count={totalPages} page={page} onChange={(_, p) => setPage(p)} />
        </Box>
      )}
    </Box>
  );
};

export default OfferwallTransactions;
